// extracted by mini-css-extract-plugin
module.exports = {"tabs-container":"tabs-container_2vYd","tab-text":"tab-text_2ALI","tab-text-active":"tab-text-active_D6VO"};